// extracted by mini-css-extract-plugin
module.exports = {"favourite":"x_N"};